export default __webpack_public_path__ + "static/media/Jerseytex Limited.bc9115db.jpg";